import axios from "axios";

import { BFF_URL } from "utils/urls";

export const BFFClient = (token?: string) => {
  const authToken = token?.includes("Bearer") ? token : `Bearer ${token}`;

  return axios.create({
    baseURL: BFF_URL,
    headers: {
      xsrfCookieName: "csrftoken",
      xsrfHeaderName: "X-CSRFToken",
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: authToken || false,
    },
  });
};
